import { qs, qsa, add, remove } from "@fluorescent/dom";
import { intersectionWatcher, delayOffset } from "@/lib/animation";
import getMediaQuery from "@/lib/media-queries";

const selectors = {
  stickyAnnouncement:
    ".announcement-bar:not([data-enable-sticky-announcement-bar='never'])",
  stickyHeader: ".header[data-enable-sticky-header='true']",
  divider: ".collection__divider",
  partial: "[data-partial]",
  filterBar: "[data-filter-bar]",
  mobileFilterBar: "[data-mobile-filters]",
  productItems: ".animation--item:not(.animation--item-revealed)",
};

const classes = {
  hideProducts: "animation--collection-products-hide",
  itemRevealed: "animation--item-revealed",
  stickyFilterBar: "filter-bar--sticky",
};

export default node => {
  const stickyAnnouncement = qs(selectors.stickyAnnouncement, document);
  const stickyHeader = qs(selectors.stickyHeader, document);
  const divider = qs(selectors.divider, document);
  const partial = qs(selectors.partial, node);
  const filterbarEl = qs(selectors.filterBar, node);
  const mobileFilterBarEl = qs(selectors.mobileFilterBar, node);
  let filterbarObserver = null;
  let mobileFilterBarObserver = null;

  if (filterbarEl) {
    filterbarObserver = intersectionWatcher(filterbarEl, true);
  }

  if (mobileFilterBarEl) {
    mobileFilterBarObserver = intersectionWatcher(mobileFilterBarEl, true);
  }

  setupProductItem();

  function setupProductItem() {
    let productItems = qsa(selectors.productItems, node);

    delayOffset(node, [selectors.productItems]);
    setTimeout(() => {
      add(productItems, classes.itemRevealed);
    }, 0);
  }

  // Scroll to top of collection grid after applying filters
  // to show the newly filtered list of products
  function _scrollIntoView() {
    const dividerHeight = divider ? 1 : 0;
    let stickyAnnouncementHeight = 0;

    if (stickyAnnouncement) {
      if (
        (window.matchMedia(getMediaQuery("below-960")).matches &&
          stickyAnnouncement
            .getAttribute("data-enable-sticky-announcement-bar")
            .includes("mobile")) ||
        stickyAnnouncement
          .getAttribute("data-enable-sticky-announcement-bar")
          .includes("desktop")
      ) {
        stickyAnnouncementHeight =
          stickyAnnouncement.getBoundingClientRect().height;
      }
    }

    const stickyHeaderHeight = stickyHeader
      ? stickyHeader.getBoundingClientRect().height
      : 0;

    const y =
      node.getBoundingClientRect().top +
      window.scrollY +
      dividerHeight -
      stickyAnnouncementHeight -
      stickyHeaderHeight;

    window.scrollTo({ top: y, behavior: "smooth" });
  }

  function updateContents() {
    setupProductItem();
    remove(partial, classes.hideProducts);
    _scrollIntoView();
  }

  function infiniteScrollReveal() {
    setupProductItem();
  }

  return {
    updateContents,
    infiniteScrollReveal,
    destroy() {
      filterbarObserver?.destroy();
      mobileFilterBarObserver?.destroy();
    },
  };
};
